import { useEffect, useContext } from 'react'

import { GeolocalizationContext } from '../../contexts/geolocalization-context'
import countryData from '../../../data/country-groups.json'
import { getCountryLegalAge } from './country-legal-age'
import { getCountryRatings } from './country-ratings'

/**
 * Get the current user's country legal age and game ratings
 */
const CountryLegalSettings = props => {
  const { ageGate, currentCountryCode, currentLegalAge, rating } = useContext(GeolocalizationContext)
  const [gameRating, setGameRating] = rating
  const [countryCode, setCountryCode] = currentCountryCode
  const [countryLegalAge, setCountryLegalAge] = currentLegalAge
  const [ageGateSettings, setAgeGateSettings] = ageGate
  const customRatingsData = props.data ? props.data : null

  useEffect(() => {
    if (process.env.GATSBY_GEOLOCALIZATION) {
      // Set User's country legal Age
      getCountryLegalAge(countryData, customRatingsData).then(function (data) {
        const legalAge = data[0]
        setCountryLegalAge(legalAge)

        // Set age gate settings depending of user's location
        const ageGateEnabled = data[1]
        const ageGateLocking = data[2]
        const ageGateFullPage = data[3]
        const gatingSettings = {
          enabled: ageGateEnabled,
          locking: ageGateLocking,
          fullPage: ageGateFullPage
        }
        setAgeGateSettings(prev => ({ ...prev, ...gatingSettings }))
      })

      // Set User's country game ratings
      getCountryRatings(countryData, customRatingsData).then(function (data) {
        setCountryCode(data.countryCode)
        setGameRating(data)
      })
    }
  }, [])

  return ''
}
export default CountryLegalSettings